import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgToestemmingGevelreclame = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      d="M35 17H22v12h13z"
    />
    <path
      fill="#F170B8"
      d="M20 5H5v30h15z"
    />
    <path
      fill="#F8BADD"
      d="M9 25H5v10h4zM17.03 25H11v6.03h6.03z"
    />
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="M5 7.98h17v3.51c0 1.94-1.52 3.51-3.4 3.51s-3.4-1.57-3.4-3.51c0 1.94-1.52 3.51-3.4 3.51s-3.4-1.57-3.4-3.51C8.4 13.43 6.88 15 5 15z"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      d="M23.44 19.5h2.25l.79 3.28c.11.46.25 1.12.25 1.12l.17-1.12.55-3.28h2.09l.56 3.28.17 1.12s.14-.66.25-1.12l.81-3.28h2.25l-1.77 7h-2.63l-.5-2.95-.17-1.12s-.09.66-.16 1.12l-.48 2.95h-2.63l-1.77-7z"
    />
    <path
      stroke="#00215B"
      strokeMiterlimit={10}
      d="M17 17h18"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgToestemmingGevelreclame);

export default ForwardRef;
